import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-attachment",
  templateUrl: "./med-icon-attachment.component.html",
})
export class MedIconAttachmentComponent extends SvgMixinComponent {}
